export default __webpack_public_path__ + "static/media/default.62fb99b9bc0427c477f0cbe82411d8dd.png";